import {useState, useEffect} from 'react'
import './home.css'
import { images } from '../../Data/slideshow';
import { Link } from 'react-router-dom';

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [fadeDirection, setFadeDirection] = useState('fade-in');

  useEffect(()=>{
    const interval = setInterval(()=>{
      setFadeDirection('fade-out');
      setTimeout(()=>{

        setCurrentIndex((currentIndex + 1) % images.length);
        setFadeDirection('fade-in');
      }, 1000)
    },5000);
    setIntervalId(interval);
    return ()=> clearInterval(interval);
  },[currentIndex])

  return (
    <div className='container'>
        <div className='split_section'>
            <div className='slideShow_content'>
                <h1><span className='first'>emthonjeni</span> wokuphila <span className='second'>community</span> <span className='third'>development</span> <span className='forth'>center</span></h1>
                <h3>is more than a center, it is the</h3>
                <h2>fountain of life</h2>
                <p>Dedicated to making a positive impact, emthonjeni wokuphila community development center strives to address the unique needs of our community. through education, ecomomic empowerment, and social development initiatives, we aim to create lasting change and improve the quality of life for all</p>
                <Link to='/volunteer' className='linktag'><button className='slide_btn'>Join Us</button></Link>
            </div>
            <div className='slide_show'>
                <img src={images[currentIndex].image} alt='' className={`${fadeDirection}`}/>
                <div className='indicators'>
                  {images.map((image, index)=>(
                  <div key ={image.id} className={`indicator $ {currentIndex === index ? 'on' : ""}`} onClick={()=> setCurrentIndex(index)}/>
                  ))}
                </div>
            </div>
        </div>
        <div className='program_container'>
          <div className='program_heading'>
            <h1>Our Programs</h1>
          </div>
          <div className='service_container'>
            <div className='service_card_1'>
              <div className='maroon_heading'>
                <h1>Day care</h1>
              </div>
              <p>6 months - 4.5 years old children</p>
              <p>english as medium language.</p>
              <p>nutritious menu, with breakfast, lunch and snakcs.</p>
            </div>

            <div className='service_card_2'>
              <div className='yellow_heading'>
                <h1>aftercare</h1>
              </div>
              <p>grade R - 12</p>
              <p>homework assistance, study groups and life skills</p>
              <p>sports activities such as basic gymnastics and music lessons</p>
              <p>cultural activities such as chess, drama, dancing & choir</p>
              <p>nutritious menu, with breakfast, lunch and snacks and saving groups for parents anf guardians or aftercare children as a bonus</p>
            </div>
            
            <div className='service_card_3'>
              <div className='blue_heading'>
                <h1>saturday & sunday extra classes</h1>
              </div>
              <p>for grade 11 - 12 for school subjects that needs support</p>
              <p>homeworks assistance, study groups and life skills</p>
              <p>lacking subjects support</p>
            </div>

            <div className='service_card_4'>
              <div className='orange_heading'>
                <h1>community development & missionery services</h1>
              </div>
              <p>For all community members</p>
              <p>Empowering our community through various initiatives</p>
              <p>Extending our care and kindness globally</p>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Home